function convertISOToNormalDate(isoDate: string): string {
  const date: Date = new Date(isoDate);

  // Format the date
  const formattedDate: string = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;

  // Format the time
  const hours        : number = date.getHours();
  const minutes      : number = date.getMinutes();
  const formattedTime: string = `${hours}:${minutes < 10 ? "0" : ""}${minutes}`;

  // Combine the formatted date and time
  return `${formattedDate} ${formattedTime}`;
}

export default convertISOToNormalDate;
